module.exports = __webpack_public_path__ + "88c3-primary.png";